(function(){


function initWallPreview(){


const modal =
document.getElementById(
"wall-preview-modal"
);


const openBtn =
document.querySelector(
".preview-wall-btn"
);


const closeBtn =
document.getElementById(
"close-wall-preview"
);


const background =
document.getElementById(
"wall-background"
);


const artwork =
document.getElementById(
"wall-art-image"
);


const frameImage =
document.getElementById(
"wall-frame-image"
);




if(!modal || !openBtn){

console.log(
"Wall preview missing"
);

return;

}




if(modal.parentElement !== document.body){

document.body.appendChild(modal);

}





let currentSizeConfig = null;

let currentFrame = null;






// =================================
// Product Config
// =================================


function getProductConfig(){


const sku =
window.CURRENT_SKU;



if(
!sku ||
!window.ART_CONFIG ||
!window.ART_CONFIG.get
){

return null;

}



return window.ART_CONFIG.get(
sku
);


}









// =================================
// Position Sync
// =================================


function syncPosition(x,y){



artwork.style.left =
x+"%";


artwork.style.top =
y+"%";



frameImage.style.left =
x+"%";


frameImage.style.top =
y+"%";



}







// =================================
// Scene
// =================================


function applyScene(sceneName){


const scene =
window.AI_WALL_CONFIG
?.scenes
?.[sceneName];



if(!scene){

console.log(
"Scene missing",
sceneName
);

return;

}




if(scene.image){

background.src =
scene.image;

}




if(scene.anchor){

syncPosition(
scene.anchor.x,
scene.anchor.y
);

}



}



// 给 touch 使用

window.WALL_PREVIEW_APPLY_SCENE =
applyScene;









// =================================
// Size
// =================================

function applyProductSize(size){


const product =
getProductConfig();



if(!product){

return;

}



const preview =
product.wallPreview;



const sizeConfig =
window.AI_WALL_CONFIG
?.products
?.[preview.shape]
?.sizes
?.[size];



if(!sizeConfig){

return;

}




/*
    核心：
    只控制 width
    高度由 aspect-ratio 自动保持
*/


artwork.style.width =
sizeConfig.scale + "%";



frameImage.style.width =
(
sizeConfig.scale *
1.12
)
+"%";




currentSizeConfig =
sizeConfig;



updateFrameSize();



}

// =================================
// Frame Size
// =================================

function updateFrameSize(){



if(
!currentSizeConfig ||
!currentFrame
){

return;

}



const frameConfig =
window.AI_WALL_CONFIG
?.frames
?.[currentFrame];



if(!frameConfig){

return;

}



const scale =
frameConfig.scale || 1.1;




frameImage.style.width =

(
currentSizeConfig.scale *
scale
)

+"%";



}



// =================================
// Frame
// =================================


function applyFrame(frame){


const frameConfig =
window.AI_WALL_CONFIG
?.frames
?.[frame];



if(!frameConfig){

return;

}



frameImage.src =
frameConfig.image;



currentFrame =
frame;



updateFrameSize();


}









// =================================
// Render Size
// =================================


function renderSizeButtons(){



const product =
getProductConfig();



if(!product){

return;

}



const preview =
product.wallPreview;



const sizes =
window.AI_WALL_CONFIG
?.products
?.[preview.shape]
?.sizes;



const box =
document.querySelector(
".wall-size-options"
);



if(!sizes || !box){

return;

}



box.innerHTML="";



Object.keys(sizes)
.forEach(size=>{


const btn =
document.createElement(
"button"
);



btn.className =
"size-btn";


btn.innerText =
size;



if(size===preview.defaultSize){

btn.classList.add(
"active"
);

}




btn.onclick=function(){


document
.querySelectorAll(
".size-btn"
)
.forEach(b=>{

b.classList.remove(
"active"
);

});



this.classList.add(
"active"
);



applyProductSize(
size
);



};



box.appendChild(btn);



});



}









// =================================
// Render Frame
// =================================


function renderFrameButtons(){



const product =
getProductConfig();



if(!product){

return;

}



const preview =
product.wallPreview;



const frames =
window.AI_WALL_CONFIG
?.frames;



const box =
document.querySelector(
".wall-frame-options"
);



if(!frames || !box){

return;

}



box.innerHTML="";





Object.keys(frames)
.forEach(frame=>{


const btn =
document.createElement(
"button"
);



// 颜色球

btn.className =
"frame-btn " + frame;



btn.innerText="";





if(frame===preview.defaultFrame){

btn.classList.add(
"active"
);

}




btn.onclick=function(){



document
.querySelectorAll(
".frame-btn"
)
.forEach(b=>{

b.classList.remove(
"active"
);

});




this.classList.add(
"active"
);



applyFrame(
frame
);



};



box.appendChild(btn);



});





applyFrame(
preview.defaultFrame
);



}









// =================================
// Open
// =================================


openBtn.addEventListener(
"click",
function(e){


e.preventDefault();



const img =
document.getElementById(
"main-preview"
)?.src;



if(img){

artwork.src =
img;

}



modal.style.display =
"flex";


document.body.style.overflow =
"hidden";





applyScene(
"living"
);





renderSizeButtons();


renderFrameButtons();





const product =
getProductConfig();



if(product){


applyProductSize(
product.wallPreview.defaultSize
);



}



});









// =================================
// Close
// =================================


function closeModal(){


modal.style.display =
"none";


document.body.style.overflow =
"";


}





closeBtn.addEventListener(
"click",
closeModal
);





modal.addEventListener(
"click",
function(e){


if(e.target===modal){

closeModal();

}


});





}



if(
document.readyState==="loading"
){

document.addEventListener(
"DOMContentLoaded",
initWallPreview
);


}else{


initWallPreview();


}



})();